export default __webpack_public_path__ + "static/media/genesys.7649e291.png";